export default __webpack_public_path__ + "static/media/no-results.2f0911db.svg";